module.exports = __webpack_public_path__ + "img/frame (256).aa7a8e58.jpg";